import type { HelpFile } from '../../types/help'
import { RemoveRoleDialogTestIds } from '../../../testids/RemoveRoleDialogTestIds'

export const removeRoleDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [RemoveRoleDialogTestIds.removeRoleDialogBody]:
      'Confirm removal of the role from this service account.',
    [RemoveRoleDialogTestIds.removeRoleDialogTitle]: 'Remove Role',
  },
}
